module.exports = __webpack_public_path__ + "img/rsvp-text.c1c08756.svg";